import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../Common/Configurations/AuthContext";
import Header from "../../../Common/Layout/Header";
import BusOffers from "../../../Components/Advertisements/BusOffers";
import SearchBusPanel4 from "../SearchBusPanel/SearchBusPanel4";
import styles from "./SearchBus4.module.css";

const SearchBus4 = ({ mode, onNavigate, templateId, branding }) => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
 const handleSearch = (searchQuery) => {
    // 👇 Use the 3-mode logic
    if (mode === "builder") {
        onNavigate({ name: "bus-results", params: { searchQuery } });
    } else if (mode === "preview") {
        navigate(`/template-preview/${templateId}/bus-results`, { state: { searchQuery } });
    } else {
        navigate("/template/bus/results", { state: { searchQuery } });
    }
  };

  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }

  return (
    <div id="layout-wrapper">
      
      
      {/* Hero Section with Full-Screen Scrolling Background */}
      <section className={styles.heroSection}>
        {/* Full Screen Scrolling Background */}
        <div className={styles.bgScroller}>
          <div className={styles.bgTrack}>
            {/* First set of images */}
            <div className={styles.bgSlide}>
              <img src="https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=600&q=80" alt="Modern Bus" />
              <img src="https://images.unsplash.com/photo-1570125909517-53cb21c89ff2?auto=format&fit=crop&w=600&q=80" alt="Luxury Bus" />
              <img src="https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=600&q=80" alt="Volvo Bus" />
              <img src="https://images.unsplash.com/photo-1570125909517-53cb21c89ff2?auto=format&fit=crop&w=600&q=80" alt="Bus Highway" />
              <img src="https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=600&q=80" alt="Mercedes Bus" />
              <img src="https://images.unsplash.com/photo-1570125909517-53cb21c89ff2?auto=format&fit=crop&w=600&q=80" alt="Scania Bus" />
              <img src="https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=600&q=80" alt="Electric Bus" />
              <img src="https://images.unsplash.com/photo-1570125909517-53cb21c89ff2?auto=format&fit=crop&w=600&q=80" alt="Bus Interior" />
            </div>
            {/* Duplicate set for seamless loop */}
            <div className={styles.bgSlide}>
                          <img src="https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=600&q=80" alt="Modern Bus" />
              <img src="https://images.unsplash.com/photo-1570125909517-53cb21c89ff2?auto=format&fit=crop&w=600&q=80" alt="Luxury Bus" />
              <img src="https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=600&q=80" alt="Volvo Bus" />
              <img src="https://images.unsplash.com/photo-1570125909517-53cb21c89ff2?auto=format&fit=crop&w=600&q=80" alt="Bus Highway" />
              <img src="https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=600&q=80" alt="Mercedes Bus" />
              <img src="https://images.unsplash.com/photo-1570125909517-53cb21c89ff2?auto=format&fit=crop&w=600&q=80" alt="Scania Bus" />
              <img src="https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=600&q=80" alt="Electric Bus" />
              <img src="https://images.unsplash.com/photo-1570125909517-53cb21c89ff2?auto=format&fit=crop&w=600&q=80" alt="Bus Interior" />
            </div>
          </div>
        </div>

        {/* Dynamic Gradient Overlay */}
        <div className={styles.gradientOverlay}></div>

        {/* Content Container */}
        <div className={styles.contentWrapper}>
          {/* Floating Elements */}
          

          {/* Main Content */}
          <div className={styles.mainContent}>
           

            {/* Headline */}
            <h1 className={styles.headline}>
              <span className={styles.headlineLarge}>YOUR JOURNEY BEGINS HERE</span>
             
            </h1>

            {/* Description */}
            <p className={styles.description}>
              Experience the future of travel with India's most advanced bus fleet
            </p>

            {/* Search Panel */}
            <div className={styles.searchPanel}>
              <SearchBusPanel4 onSearch={handleSearch} />
            </div>

            {/* Trust Indicators */}
            <div className={styles.trustIndicators}>
              <div className={styles.trustItem}>
                <svg className={styles.checkIcon} viewBox="0 0 24 24">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/>
                </svg>
                <span>2 Million+ Riders</span>
              </div>
              <div className={styles.trustItem}>
                <svg className={styles.checkIcon} viewBox="0 0 24 24">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/>
                </svg>
                <span>98% On-Time</span>
              </div>
              <div className={styles.trustItem}>
                <svg className={styles.checkIcon} viewBox="0 0 24 24">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/>
                </svg>
                <span>24/7 Support</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Wave */}
        <div className={styles.bottomWave}>
          <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 120L60 105C120 90 240 60 360 45C480 30 600 30 720 37.5C840 45 960 60 1080 67.5C1200 75 1320 75 1380 75L1440 75V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="currentColor"/>
          </svg>
        </div>
      </section>

      {/* Main Content */}
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <BusOffers />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchBus4;